import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { Page } from "src/app/model/Page";
import { ProjectModel } from "src/app/model/ProjectModel";
import { MasterService } from "src/app/services/master.service";

@Component({
  selector: "app-secure-project-list",
  templateUrl: "./project-list.component.html",
  styleUrls: ["./project-list.component.scss"],
})
export class ProjectListComponent implements OnInit {
  page: Page<ProjectModel>;
  filterForm: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;
  
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource: MatTableDataSource<ProjectModel> = new MatTableDataSource();
  displayedColumns: string[] = [
    "id",
    "project",
    "board",
    "action",
  ];
  pageSizeOptions: number[] = [10, 25, 100];
  isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;

  constructor(
    private router: Router,
    private masterService: MasterService,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.filterForm = new FormGroup({
      filterText: new FormControl(null, [Validators.required, Validators.minLength(3)])
    });

    this.onLoad();
  }

  resetFilter() {
    this.filterForm.controls['filterText'].setValue(null);
    this.onLoad();
  }

  onLoad() {
    this.isLoading = true;
    this.masterService.fetchProjectList(this.currentPage, this.pageSize, this.filterForm.value.filterText).subscribe((page) => {
      this.page = page;
      this.dataSource = new MatTableDataSource(page.content);
      setTimeout(() => {
        this.paginator.pageIndex = this.currentPage;
        this.paginator.length = page.totalElements;
      });
      this.isSearchDisabled = false;
      this.isLoading = false;
    },
    (error) => {
        console.log(error);
        this.isLoading = false;
        this.isSearchDisabled = false;
    });
  }

  onSearch() {
    if (this.filterForm.valid) {
      this.onLoad();
    }
    else {
      this._snackBar.open("Please enter Filter text (minimum - 3 char) for Project", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 3 * 1000,
      });
      this.isSearchDisabled = false;
    }
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.onLoad();
  }

  edit(key: number) {
    this.router.navigate(['/secure', 'project', 'au', key]);
  }

  deactivate(key: number) {
    if(confirm("Do you want to De-Activate the Project")) {
      this.masterService.toggleActivationProject(key, 'N').subscribe((data: any)=>{
        if(data.status === 'SUCCESS') {
          let selectedObj = this.page.content.find(o => o.key === key);
          selectedObj.activeFlag = 'N';
        }
        else {
          this.masterService.errorToast(data.errorMessage);
        }
      });
    } 
  }
 
  activate(key: number) {
    if(confirm("Do you want to Activate the Project")) {
      this.masterService.toggleActivationProject(key, 'Y').subscribe((data: any)=>{
        if(data.status === 'SUCCESS') {
          let selectedObj = this.page.content.find(o => o.key === key);
          selectedObj.activeFlag = 'Y';
        }
        else {
          this.masterService.errorToast(data.errorMessage);
        }
      });
    } 
  }
    
}